/**
 * Route paths for the miscellaneous master module.
 * Single source of truth — reuse these instead of hard-coding `/blank-page` strings.
 */
export const MASTER_ROUTES = {
  blankPage: "/blank-page",
} as const;
